import { render, staticRenderFns } from "./self-extinguishing.vue?vue&type=template&id=2d455ed8&"
import script from "./self-extinguishing.vue?vue&type=script&lang=js&"
export * from "./self-extinguishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports